const PREFIX = 'wpc_intake_draft_v1:'
const MAX_AGE = 24 * 60 * 60 * 1000

export function getDraftStorage () {
  try { return window.localStorage } catch (error) { return null }
}

export function draftKey (auth, envKey, code) {
  const owner = String(auth.userId || auth.externalUserId || '').trim()
  if (!owner) return ''
  return PREFIX + JSON.stringify([owner, envKey || auth.envKey || '', String(code || '').trim() || '__new__'])
}

export function readDraft (storage, key, now = Date.now()) {
  if (!key) return null
  try {
    const raw = storage.getItem(key)
    if (!raw) return null
    const item = JSON.parse(raw)
    if (item.version !== 1 || !Number.isFinite(item.savedAt) || now - item.savedAt > MAX_AGE || item.savedAt > now || !item.snapshot) {
      storage.removeItem(key)
      return null
    }
    return item
  } catch (error) { return null }
}

export function writeDraft (storage, key, snapshot, checkpoint, scrollTop, now = Date.now()) {
  if (!key) return false
  try {
    // Expired drafts are removed even when the user starts another check number.
    for (let i = storage.length - 1; i >= 0; i--) {
      const oldKey = storage.key(i)
      if (oldKey && oldKey.indexOf(PREFIX) === 0) readDraft(storage, oldKey, now)
    }
    storage.setItem(key, JSON.stringify({ version: 1, savedAt: now, snapshot, checkpoint, scrollTop }))
    return true
  } catch (error) { return false }
}

export function removeDraft (storage, key) {
  try { if (key) storage.removeItem(key) } catch (error) {}
}

export function patientFingerprint (payload) {
  const result = Object.assign({}, payload)
  // The returned patient id and refreshed GPS values do not change entered basic information.
  ;['isEdit', 'patientId', 'latitude', 'longitude', 'accuracy'].forEach(key => { delete result[key] })
  return JSON.stringify(result)
}

export function mergeNonEmpty (current, incoming) {
  const result = Object.assign({}, current)
  Object.keys(incoming).forEach(key => {
    const value = incoming[key]
    if (value !== null && value !== undefined && value !== '' && (!Array.isArray(value) || value.length)) result[key] = value
  })
  return result
}

export function validBirthDate (value, now = new Date()) {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return false
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const date = new Date(year, month - 1, day)
  return year >= 1900 && date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day && date <= now
}

// Diagnostic metadata deliberately excludes URLs, ticket, form fields and image data.
export function reportWorkflowFailure (phase, error) {
  const status = error && error.response ? error.response.status : 0
  console.warn('[wpc-h5] workflow failure', { phase, status, category: /timeout/i.test((error && error.message) || '') ? 'timeout' : 'request' })
}



// WEBPACK FOOTER //
// ./src/utils/surveyWorkflow.js